module.exports = __webpack_public_path__ + "img/pdf.ed0fff5b.svg";